import React, { useState, useEffect } from 'react'
import { Form, Button, Dropdown, DropdownButton, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux'
import { hideModal } from '../../../actions/modalsActions';
import { updateItem } from '../../../actions/relationActions';
import CyberSecurity from '../../../apis/cyberSecurityData';

import "react-datepicker/dist/react-datepicker.css";
import AdminForm from './AdminForm';

let AddNewItem = (props) => {
    const [error, setError] = useState('');
    const [existItem, setExistItem] = useState(null);

    const initialValues = {
        mainCategory: 'Stories',
        image: require('../../../images/PlaceHolderImage.jpg'),
        newTag1: props.currentUser.firstName + ' ' + props.currentUser.lastName,
        newTag5: 'Article',
        newTag6: getDate(new Date()),
        exactDate: new Date(),
        mainCategoryType: 'CYBER STORY',
        postDate: new Date()
    }

    const onSubmit = async (item) => {

        //checking the count of the items in the database with the same url
        //if the count is > 0 that means there is an existing item with the same url
        if (item.url1 && item.url1 !== '') {
            // 1. check for existeing item with the same url1
            // the following request will respond with the number of items in the database with the url1 of the entered item in the form
            const urlResponse = await CyberSecurity.get('/checkurlexist', {
                params: {
                    url1: item.url1
                },
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            })
            //code here will run if there is an existing item with the same url
            if (urlResponse.data && urlResponse.data.count > 0) return setExistItem(item);
        }

        addItem(item);
    }

    const addItem = async (item) => {
        const response = await CyberSecurity.post('/addnewitem', { item }, {
            headers: {
                Authorization: `Bearer ${props.accessToken}`
            }
        })

        if (response.data.error) return console.log({ error: response.data.error })

        props.updateItem(response.data)
        props.hideModal();
    }

    return (
        <div>
            <AdminForm initialValues={initialValues} onFormSubmit={onSubmit} />
            {existItem && <div className="d-flex align-items-center">
                <h3 className="p-0 m-0 mr-2" style={{ color: 'red' }}>This url is allready Exists</h3>
                <Button size="sm" onClick={() => addItem(existItem)}>Add anyway</Button>
            </div>}
        </div>
    )
}

function getDate(date) {
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var day = a.getDate();
    return (`${month} ${day}, ${year}`)
}

const mapStateToProps = (state, ownProps) => {
    return {
        accessToken: state.accessToken,
        currentUser: state.currentUser,
        filters: state.filters
    }
}

export default connect(mapStateToProps, { hideModal, updateItem })(AddNewItem);
